import { InjectionToken } from '@angular/core';
import { ConfigConstants, CONNECTION_ERROR_CODES } from '@evorait/pace-core';
import { Observable } from 'rxjs';
import { FormState } from '../store/state/form.state';
import { FormIdentifier } from '../types/form-identifier';
import { FormsConstants } from '../types/forms-constants';
import { ParticipantCopyId } from '../types/participant-copy';
import { ManuallyIndividualizedComponents } from '../types/individualization-component';

export interface FormsWriteInterface {
    submitMaster(form: FormState, saveMode: FormsConstants.SUBMIT_STATUS): Observable<void | CONNECTION_ERROR_CODES>;

    submitParticipantCopies(
        form: FormState,
        participantCopyIds: ParticipantCopyId[],
    ): Observable<void | CONNECTION_ERROR_CODES>;

    releaseLock(id: FormIdentifier): Observable<void | CONNECTION_ERROR_CODES>;

    refreshXML(form: FormIdentifier): Observable<unknown>;
}

export const FormsWriteInstanceToken = new InjectionToken<FormsWriteInterface>('FormsWriteInterface');

export type ODataSubmitFormPayload = {
    EquipmentId: string;
    FormDocid: string;
    GID: string;
    Savemode: FormsConstants.SUBMIT_STATUS;
    XMLContent: string;
    Country: string;
    CompanyCode: string;
    NotificationNo: string;
    TaskNumber: string;
    NotificationType: ConfigConstants.NotificationTypes;
    TechIdentNum: string;
    SerialNum: string;
    CSESignatureFileName: string;
    CSEMimeType: FormsConstants.MIME_TYPE;
    CSEBase64: string;
    CustomerSignatureFileName: string;
    CustomerMimeType: FormsConstants.MIME_TYPE;
    CustomerBase64: string;
    EquiShortDesc: string;
    Email_01: string;
    Email_02: string;
    Email_03: string;
    Email_04: string;
    Email_05: string;
    Email_06: string;
    Email_07: string;
    Email_08: string;
    Email_09: string;
    Email_10: string;
    SalesOrg?: string;
    Plant?: string;
    Material?: string;
    ComponentSerialNumber?: string;
    ComponentMaterialNumber?: string;
    ManIndividualizationComponents?: ManuallyIndividualizedComponents[];
};

export type ODataSubmitParticipantCopyPayload = {
    EquipmentId: string;
    FormDocid: string;
    GID: string;
    XMLContent: string;
    Country: string;
    CompanyCode: string;
    NotificationNo: string;
    TaskNumber: string;
    NotificationType: ConfigConstants.NotificationTypes;
    TechIdentNum: string;
    SerialNum: string;
    CSESignatureFileName: string;
    CSEMimeType: FormsConstants.MIME_TYPE;
    CSEBase64: string;
    CustomerSignatureFileName: string;
    CustomerMimeType: FormsConstants.MIME_TYPE;
    CustomerBase64: string;
    ParticipantEmail: string;
    ParticipantName: string;
    EquiShortDesc: string;
    UniqueID: ParticipantCopyId;
};

export type ODataReleaseLockPayload = {
    EquipmentId: string;
    FormDocid: string;
};

export type ODataRefreshXMLPayload = {
    EquipmentId: string;
    FormDocid: string;
};
